// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `    .pageGameSlot_mainContainer__BHwxq {
        max-height: 90vh;

        display: flex;

        flex-direction: column;
        padding: 10px;
        margin-top: 30px;

        /*height: 100%; !* Добавьте высоту 100% для гарантии растяжения на всю высоту *!*/




    }

    .pageGameSlot_disable__Vkoru {
        display: none !important;
    }

    .pageGameSlot_containerTools__mXJnJ {
        position: absolute;
        margin: 10px;
        display: flex;
        justify-content: center;
        gap: 10px;
        margin-bottom: 5px;
    }


    .pageGameSlot_containerInfGame__PhUs2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;


    }

    .pageGameSlot_inf__Gbp7I {
        display: flex;
        gap: 1rem;
        align-items: center;

    }

    .pageGameSlot_name__9Yz\\+K {
        color: white;
        font-family: Poppins, sans-serif;
        font-weight: 700;
        font-size: 25px;
    }

    .pageGameSlot_img_container__2YAyn {
        width: 130px;
        border-radius: 5px;
    }

    .pageGameSlot_img_container__2YAyn img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }

    .pageGameSlot_containerIframe__-v9mj {

        width: 100%;

        display: flex;


        /*box-shadow: -1px 1px 10px 3px #8266ff;*/



    }

    .pageGameSlot_containerIframe__-v9mj iframe {
        border-radius: 10px;

    }

    .pageGameSlot_buttonContainer__Ha2z5 button {
        font-weight: 700;
        font-size: 18px;
        background-color: transparent;
        /* Сделать фон кнопки прозрачным */

        border: 1px solid #6d54c8;
        /* Green */
        transition-duration: 0.2s;
        border-radius: 10px;
        line-height: 20px;
        padding: 10px;
        color: white;
        font-family: Gilroy, sans-serif;


        text-align: center;
        text-decoration: none;
        display: inline-block;

    }

    .pageGameSlot_buttonContainer__Ha2z5 button:hover {
        background-color: #6d54c8;
    }

    iframe {
        transition: opacity 0.8s ease-in;
        height: 100%;
    }

    @media screen and (max-width: 799px) {
        .pageGameSlot_mainContainer__BHwxq {
            margin-left: 0;
            margin-bottom: 40px;
            padding: 10px;
        }

        .pageGameSlot_img_container__2YAyn {
            width: 80px;
            height: 80px;
        }

        .pageGameSlot_name__9Yz\\+K {
            font-size: 15px;
            font-weight: 500;
        }

        .pageGameSlot_buttonContainer__Ha2z5 {
            margin-right: 0;
        }

        .pageGameSlot_buttonContainer__Ha2z5 button {
            padding: 5px;
            font-size: 16px;
            font-weight: 500;
        }

        .pageGameSlot_containerInfGame__PhUs2 {
            margin-bottom: 10px;
        }
    }

    @media only screen and (max-width: 1000px) {
        .pageGameSlot_mainContainer__BHwxq {

            gap: 0;
            padding: 0;
        }

        .pageGameSlot_containerInfGame__PhUs2 {
            padding: 10px;
            margin-bottom: 0;
        }

        .pageGameSlot_containerIframe__-v9mj iframe {
            outline: 0;
        }

        /*.containerIframe{*/
        /*    margin: auto 0;*/

        /*    height: 290px;*/
        /*}*/

    }`, "",{"version":3,"sources":["webpack://./src/Pages/SlotsIgrator/components/pageGame/pageGameSlot.module.css"],"names":[],"mappings":"IAAI;QACI,gBAAgB;;QAEhB,aAAa;;QAEb,sBAAsB;QACtB,aAAa;QACb,gBAAgB;;QAEhB,iFAAiF;;;;;IAKrF;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,SAAS;QACT,kBAAkB;IACtB;;;IAGA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,mBAAmB;;;IAGvB;;IAEA;QACI,aAAa;QACb,SAAS;QACT,mBAAmB;;IAEvB;;IAEA;QACI,YAAY;QACZ,gCAAgC;QAChC,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;;QAEI,WAAW;;QAEX,aAAa;;;QAGb,yCAAyC;;;;IAI7C;;IAEA;QACI,mBAAmB;;IAEvB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,6BAA6B;QAC7B,kCAAkC;;QAElC,yBAAyB;QACzB,UAAU;QACV,yBAAyB;QACzB,mBAAmB;QACnB,iBAAiB;QACjB,aAAa;QACb,YAAY;QACZ,+BAA+B;;;QAG/B,kBAAkB;QAClB,qBAAqB;QACrB,qBAAqB;;IAEzB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gCAAgC;QAChC,YAAY;IAChB;;IAEA;QACI;YACI,cAAc;YACd,mBAAmB;YACnB,aAAa;QACjB;;QAEA;YACI,WAAW;YACX,YAAY;QAChB;;QAEA;YACI,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,eAAe;QACnB;;QAEA;YACI,YAAY;YACZ,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,mBAAmB;QACvB;IACJ;;IAEA;QACI;;YAEI,MAAM;YACN,UAAU;QACd;;QAEA;YACI,aAAa;YACb,gBAAgB;QACpB;;QAEA;YACI,UAAU;QACd;;QAEA,oBAAoB;QACpB,sBAAsB;;QAEtB,qBAAqB;QACrB,IAAI;;IAER","sourcesContent":["    .mainContainer {\n        max-height: 90vh;\n\n        display: flex;\n\n        flex-direction: column;\n        padding: 10px;\n        margin-top: 30px;\n\n        /*height: 100%; !* Добавьте высоту 100% для гарантии растяжения на всю высоту *!*/\n\n\n\n\n    }\n\n    .disable {\n        display: none !important;\n    }\n\n    .containerTools {\n        position: absolute;\n        margin: 10px;\n        display: flex;\n        justify-content: center;\n        gap: 10px;\n        margin-bottom: 5px;\n    }\n\n\n    .containerInfGame {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 10px;\n\n\n    }\n\n    .inf {\n        display: flex;\n        gap: 1rem;\n        align-items: center;\n\n    }\n\n    .name {\n        color: white;\n        font-family: Poppins, sans-serif;\n        font-weight: 700;\n        font-size: 25px;\n    }\n\n    .img_container {\n        width: 130px;\n        border-radius: 5px;\n    }\n\n    .img_container img {\n        width: 100%;\n        height: 100%;\n        border-radius: 10px;\n    }\n\n    .containerIframe {\n\n        width: 100%;\n\n        display: flex;\n\n\n        /*box-shadow: -1px 1px 10px 3px #8266ff;*/\n\n\n\n    }\n\n    .containerIframe iframe {\n        border-radius: 10px;\n\n    }\n\n    .buttonContainer button {\n        font-weight: 700;\n        font-size: 18px;\n        background-color: transparent;\n        /* Сделать фон кнопки прозрачным */\n\n        border: 1px solid #6d54c8;\n        /* Green */\n        transition-duration: 0.2s;\n        border-radius: 10px;\n        line-height: 20px;\n        padding: 10px;\n        color: white;\n        font-family: Gilroy, sans-serif;\n\n\n        text-align: center;\n        text-decoration: none;\n        display: inline-block;\n\n    }\n\n    .buttonContainer button:hover {\n        background-color: #6d54c8;\n    }\n\n    iframe {\n        transition: opacity 0.8s ease-in;\n        height: 100%;\n    }\n\n    @media screen and (max-width: 799px) {\n        .mainContainer {\n            margin-left: 0;\n            margin-bottom: 40px;\n            padding: 10px;\n        }\n\n        .img_container {\n            width: 80px;\n            height: 80px;\n        }\n\n        .name {\n            font-size: 15px;\n            font-weight: 500;\n        }\n\n        .buttonContainer {\n            margin-right: 0;\n        }\n\n        .buttonContainer button {\n            padding: 5px;\n            font-size: 16px;\n            font-weight: 500;\n        }\n\n        .containerInfGame {\n            margin-bottom: 10px;\n        }\n    }\n\n    @media only screen and (max-width: 1000px) {\n        .mainContainer {\n\n            gap: 0;\n            padding: 0;\n        }\n\n        .containerInfGame {\n            padding: 10px;\n            margin-bottom: 0;\n        }\n\n        .containerIframe iframe {\n            outline: 0;\n        }\n\n        /*.containerIframe{*/\n        /*    margin: auto 0;*/\n\n        /*    height: 290px;*/\n        /*}*/\n\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `pageGameSlot_mainContainer__BHwxq`,
	"disable": `pageGameSlot_disable__Vkoru`,
	"containerTools": `pageGameSlot_containerTools__mXJnJ`,
	"containerInfGame": `pageGameSlot_containerInfGame__PhUs2`,
	"inf": `pageGameSlot_inf__Gbp7I`,
	"name": `pageGameSlot_name__9Yz+K`,
	"img_container": `pageGameSlot_img_container__2YAyn`,
	"containerIframe": `pageGameSlot_containerIframe__-v9mj`,
	"buttonContainer": `pageGameSlot_buttonContainer__Ha2z5`
};
export default ___CSS_LOADER_EXPORT___;
